'use client'

import React from 'react'
import { ThemeProvider as ContextThemeProvider } from '../contexts/ThemeContext'

interface ProvidersProps {
  children: React.ReactNode
}

export function ThemeProvider({ children }: ProvidersProps) {
  return (
    <ContextThemeProvider>
      {children}
    </ContextThemeProvider>
  )
}